{
  "version": 1,
  "asset_id": "450a533b-78d1-46f3-bba9-8982f8da73f6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/450a533b-78d1-46f3-bba9-8982f8da73f6/ind-hvac-home-services-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/450a533b-78d1-46f3-bba9-8982f8da73f6/ind-hvac-home-services-1200.avif",
  "original_filename": "ind-hvac-home-services-1200.avif",
  "size": 16873,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:05Z"
}
